import React from 'react'
import styles from './CardAppearance.module.scss'
import asideModalStore from 'Stores/asideModalStore'
import FormField from 'components/UI/AsideModal/Form/FormField'
import FormLabel from 'components/UI/AsideModal/Form/FormLabel'
import SelectCustom from 'components/ContentBox/Global/Select/SelectCustom'

const CardAppearance = () => {
  const {
    modalValues: modalValue,
    changeValue: changeValues,
    check,
  } = asideModalStore

  return (
    <div className={styles.groupForm}>
      <div className={styles.fieldSet}>
        <FormField>
          <FormLabel isRequired>{'Contact'}</FormLabel>
          <SelectCustom
            placeholder={'Contact'}
            options={[]}
            sortKey='name'
            valueID={modalValue.contact}
            onChange={(o) => changeValues(o.id, 'contact')}
            error={check('contact')}
          />
        </FormField>
        <FormField>
          <FormLabel isRequired>{'Company:'}</FormLabel>
          <SelectCustom
            placeholder={'Company'}
            options={[]}
            sortKey='name'
            valueID={modalValue.company}
            onChange={(o) => changeValues(o.id, 'company')}
            error={check('company')}
          />
        </FormField>
      </div>
      <FormLabel isRequired>{'Transaction:'}</FormLabel>
      <SelectCustom
        placeholder={'Transaction'}
        options={[]}
        sortKey='name'
        valueID={modalValue.transaction}
        onChange={(o) => changeValues(o.id, 'transaction')}
        error={check('transaction')}
      />
      <div className={styles.fieldSet}>
        <FormField>
          <FormLabel isRequired>{'Date:'}</FormLabel>
          <SelectCustom
            placeholder={'Date'}
            options={[]}
            sortKey='name'
            valueID={modalValue.date}
            onChange={(o) => changeValues(o.id, 'date')}
            error={check('date')}
          />
        </FormField>
        <FormField>
          <FormLabel isRequired>{'Responsible:'}</FormLabel>
          <SelectCustom
            placeholder={'Responsible'}
            options={[]}
            sortKey='name'
            valueID={modalValue.responsible}
            onChange={(o) => changeValues(o.id, 'responsible')}
            error={check('responsible')}
          />
        </FormField>
        <FormField>
          <FormLabel isRequired>{'Task type:'}</FormLabel>
          <SelectCustom
            placeholder={'Task type'}
            options={[]}
            sortKey='name'
            valueID={modalValue.task_type}
            onChange={(o) => changeValues(o.id, 'task_type')}
            error={check('task_type')}
          />
        </FormField>
        <FormField>
          <FormLabel isRequired>{'Text:'}</FormLabel>
          <SelectCustom
            placeholder={'Text'}
            options={[]}
            sortKey='name'
            valueID={modalValue.text}
            onChange={(o) => changeValues(o.id, 'text')}
            error={check('text')}
          />
        </FormField>
        <FormField>
          <FormLabel isRequired>{'Deal:'}</FormLabel>
          <SelectCustom
            placeholder={'Stage'}
            options={[]}
            sortKey='name'
            valueID={modalValue.deal}
            onChange={(o) => changeValues(o.id, 'deal')}
            error={check('deal')}
          />
        </FormField>
        <FormField>
          <FormLabel isRequired>{'No meaning:'}</FormLabel>
          <SelectCustom
            placeholder={'Contact'}
            options={[]}
            sortKey='name'
            valueID={modalValue.no_meaning}
            onChange={(o) => changeValues(o.id, 'no_meaning')}
            error={check('no_meaning')}
          />
        </FormField>
      </div>
    </div>
  )
}

export default CardAppearance
